// Every column list the shared-building card and the suite drawer send, in one
// place (item 552, 2026-10-19).
//
// ⛔ WHY THIS FILE EXISTS. The suite drawer asked service_providers for a
// provider-name column that does not exist. The database refused the request,
// the drawer ignored the refusal, and the crew row read "—" on every suite from
// July to October — invisible because the tab was parked. A column list that
// lives inline in a component can only be checked by opening the screen.
//
// Keeping them here lets `scripts/smoke-shared-building-view.mjs` read this
// file and send exactly these selects, as a signed-in account manager, for
// every building — so a wrong column fails `dod` instead of blanking a screen.
//
// ⛔ Keep each value a single-line string literal: the smoke reads them with a
// regex, not by importing TypeScript.

/** Building card — the member facilities of one building. */
export const BUILDING_FACILITIES_SELECT =
  'facility_id, facility_name, facility_type, facility_address, account_id, account_manager_eid, status, account_status_rag, is_pinned, is_common_area, monthly_rate, management_fee_pct';

/** Building card — the paying accounts' names. */
export const BUILDING_ACCOUNTS_SELECT = 'account_id, account_name';

/** Building card — client billing lines (member lines, and lines anchored to a member). */
export const BUILDING_LINES_SELECT =
  'assignment_id, facility_id, provider_id, billing_method, billing_rate, invoice_to, billing_account_id, cost_group_facility_id, assignment_status';

/** Building card — feedback summaries per member. */
export const BUILDING_FEEDBACK_SELECT = 'facility_id, status, feedback_date';

/** Building card — square feet per member. */
export const BUILDING_SQFT_SELECT = 'facility_id, total_sqft';

/** Building card — names of facilities outside this building that share a billing group with it. */
export const BUILDING_OUTSIDE_FACILITY_SELECT = 'facility_id, facility_name';

/**
 * Building card + suite drawer — the cleaner's name. `partner_name` is the
 * provider's display name everywhere else in the app (FacilityCleaningLines,
 * the Info tab's crew block). There is no provider-name column.
 */
export const PROVIDER_NAME_SELECT = 'provider_id, partner_name';

/** Suite drawer — access codes. */
export const DRAWER_ACCESS_SELECT = 'alarm_code, lock_code, key_location, other_access_notes';

/** Suite drawer — the crew lines. */
export const DRAWER_CREW_SELECT =
  'provider_id, crew_size, service_days_per_week, assignment_status, start_date';
